import CocktailProvider from './CocktailProvider';
export default CocktailProvider;
